const NotFound = () => (
  <h1>Welcome to Financial Metrics!!</h1>
);

export default NotFound;
